export const SUPER_ADMIN = 'SuperAdmin'
export const ADMIN = 'SuperAdmin'
export const SELLER = 'Seller'
export const DROPSHIPPER = 'SellerAdmin'
export const ADMIN_SISTECREDITO = 'AdminSistecredito'
export const VOUCHER = 'SellerVoucher'
export const COMMERCIAL_ADVISOR = 'Comercial'
export const CUSTOMER_SUPPORT = 'CustomerSupport'
export const LOGO_URL =
  'https://luegopago.blob.core.windows.net/luegopago-uploads/sellerCenter/site/img/LuegoPagoSellerCenterLogo.png'

export const ORDER_STATUS_ADMIN = 'OrderStatusAdmin'
